module.exports = __webpack_public_path__ + "static/media/HQ18_Dr-Wallach@3x.6a232ac5.png";